import { createSlice } from "@reduxjs/toolkit";
import { FormaPagamentoRecebimentoModel } from "../../../models/formaPagamentoRecebimento/formaPagamentoRecebimentoModel";
import { buscarFormaPagamentoRecebimento } from "../../../services/formaPagamentoRecebimentoService";
import { resetAll } from "../../actions/actions";

export interface FormaPagamentoRecebimentoState {
  //buscar forma de pagamento
  loading: boolean;
  busca: string;
  list: FormaPagamentoRecebimentoModel[];
  entity: FormaPagamentoRecebimentoModel;
  //internal
  modalCadastrar: boolean;
  modalDeletar: boolean;
}

const initialState: FormaPagamentoRecebimentoState = {
  //buscar forma de pagamento
  loading: false,
  busca: "",
  list: [],
  entity: {} as FormaPagamentoRecebimentoModel,
  //internal
  modalCadastrar: false,
  modalDeletar: false,
};

export const formaPagamentoRecebimentoSlice = createSlice({
  name: "formaPagamentoRecebimento",
  initialState,
  reducers: {
    //buscar forma de pagamento
    setBuscaFormaPagamentoRecebimento: (state, action) => {
      state.busca = action.payload;
    },
    setEntityFormaPagamentoRecebimento: (state, action) => {
      state.entity = action.payload;
    },
    //internal
    setModalCadastrarFormaPagamentoRecebimento: (state, action) => {
      state.modalCadastrar = action.payload;
    },
    setModalDeletarFormaPagamentoRecebimento: (state, action) => {
      state.modalDeletar = action.payload;
    },
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //buscar forma de pagamento
    builder.addCase(buscarFormaPagamentoRecebimento.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarFormaPagamentoRecebimento.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarFormaPagamentoRecebimento.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const {
  //buscar forma de pagamento
  setBuscaFormaPagamentoRecebimento,
  setEntityFormaPagamentoRecebimento,
  //internal
  setModalCadastrarFormaPagamentoRecebimento,
  setModalDeletarFormaPagamentoRecebimento,
} = formaPagamentoRecebimentoSlice.actions;

export default formaPagamentoRecebimentoSlice.reducer;
